import './paywall.css';
import { mountTemplate, hide, show } from './modal-base';
import { t } from '../../i18n';

function buildPaywallTemplate(): string {
  return /* html */ `
<div class="modal-overlay" id="pethernity-paywall" style="display:none;">
  <div class="modal-content paywall-modal">
    <h3 class="paywall-title">${t('pethernity.paywallTitle')}</h3>
    <p class="paywall-body" id="paywall-reason">${t('pethernity.paywallBody')}</p>
    <ul class="paywall-perks">
      <li>${t('pethernity.perkPhotos')}</li>
      <li>${t('pethernity.perkAds')}</li>
      <li>${t('pethernity.perkFlowers')}</li>
      <li>${t('pethernity.perkStyles')}</li>
      <li>${t('pethernity.perkReplies')}</li>
      <li>${t('pethernity.perkTemple')}</li>
    </ul>
    <button type="button" class="modal-btn paywall-cta" onclick="startPethernityCheckout()">
      ${t('pethernity.upgrade')}
    </button>
    <button type="button" class="secondary-modal-btn" onclick="closePethernityPaywall()">
      ${t('pethernity.later')}
    </button>
  </div>
</div>
`;
}

export function mountPaywallModal(): void {
  mountTemplate('pethernity-paywall', buildPaywallTemplate());
}

export function remountPaywallModal(): void {
  mountPaywallModal();
}

export function openPaywallModal(reason?: string): void {
  if (!document.getElementById('pethernity-paywall')) mountPaywallModal();
  const reasonEl = document.getElementById('paywall-reason');
  if (reasonEl) reasonEl.textContent = reason?.trim() || t('pethernity.paywallBody');
  show('pethernity-paywall');
}

export function closePaywallModal(): void {
  hide('pethernity-paywall');
}
